<template>
    <v-combobox
        ref="field"
        class="no-arrow"
        :data-cy="dataCy"
        outlined
        single-line
        v-bind="$attrs"
        v-on="$listeners"
    />
</template>

<script>
export default {
    name: `BaseCombobox`,
    props: {
        dataCy: {
            type: String,
            default: ``
        }
    }
}
</script>
